import React from "react";
import {Button, message, Modal, Popconfirm, Space, Table, Tag} from "antd";
import {AuthGroup} from "../../domains/auth-group";
import {ApiUser} from "../../domains/api-user";
import ApiUserEdit from "./api-user-edit";
import {getTimeString, request} from "../../utils/utils";
import {EyeOutlined} from "@ant-design/icons";

interface ApiUserListState {
    users: ApiUser[],
    apiUserEditVisible: boolean,
    authGroups: Map<string, AuthGroup>,
    selectedApiUser?: ApiUser
}

export default class ApiUserList extends React.Component<any, ApiUserListState> {

    constructor(props: Readonly<any> | any) {
        super(props);
        this.state = {
            users: [],
            apiUserEditVisible: false,
            authGroups: new Map<string, AuthGroup>()
        }
    }

    apiUserEditRef = React.createRef<ApiUserEdit>()

    columns = [
        {
            title: "AppKey",
            dataIndex: "appKey",
            key: "appKey",
            render: (text: string) => <label>{text}</label>
        },
        {
            title: "AppSecret",
            render: (record: ApiUser) => <span>
                <label id={record.apiUserId}>********</label>
                <span> <EyeOutlined onClick={() => {
                    const secretText = document.getElementById(record.apiUserId)!.innerText
                    if (secretText === "********") {
                        document.getElementById(record.apiUserId)!.innerText = record.appSecret
                    } else {
                        document.getElementById(record.apiUserId)!.innerText = '********'
                    }

                }
                }/></span>
            </span>
        },
        {
            title: "授权组",
            dataIndex: "authGroupEntityList",
            key: "authGroupEntityList",
            render: (text: AuthGroup[]) => {
                return text.map((x: AuthGroup) => {
                    return <Tag> {x.name} </Tag>
                })
            }
        },
        {
            title: "应用名称",
            dataIndex: "appName",
            key: "parentId",
            render: (text: string) => <label>{text}</label>
        },
        {
            title: "客户名称",
            dataIndex: "customerName",
            key: "customerName",
            render: (text: string) => <label>{text}</label>
        },
        {
            title: "有效日期",
            render: (record: ApiUser) =>
                <label>{this.getTimeString(record.signDate)} - {this.getTimeString(record.validateTime)}</label>
        },
        {
            title: "操作",
            render: (record: ApiUser) => {
                return (
                    <Space>
                        <Button type="primary" onClick={() => {
                            this.setState({selectedApiUser: record, apiUserEditVisible: true})
                            this.apiUserEditRef.current!.fillUpForm(record)
                        }
                        }>详情</Button>
                        <Button type={"primary"} danger={record.enabled} onClick={() => {
                            if (record.enabled) {
                                request({
                                    url: "/gateway/apiuser/disable",
                                    params: {id: record.apiUserId},
                                    method: "GET"
                                }).then((res) => {
                                    this.loadData()
                                })
                            } else {
                                request({
                                    url: "/gateway/apiuser/enable",
                                    params: {id: record.apiUserId},
                                    method: "GET"
                                }).then((res) => {
                                    this.loadData()
                                })
                            }
                        }}>{record.enabled ? "禁用" : "启用"}</Button>
                        <Popconfirm title={"确认要删除该ApiUser吗？"} okText={"确认"} cancelText={"取消"} onConfirm={() => {
                            request({
                                url: "/gateway/apiuser/delete",
                                params: {id: record.apiUserId},
                                method: "GET"
                            }).then((res) => {
                                if (res.data) {
                                    message.info("删除成功")
                                    this.loadData()
                                } else {
                                    message.error("删除失败")
                                }
                            })
                        }}>
                            <Button type={"primary"} danger>删除</Button>
                        </Popconfirm>
                    </Space>
                )
            }
        }
    ]

    private loadData = () => {
        request({
            url: "/gateway/apiuser/",
            method: "GET",
        }).then(res => {

            const promise: any = [];
            res.data.forEach((apiUser: ApiUser) => {
                apiUser.authGroupEntityList = [];
                apiUser.authGroupList.forEach((id: string) => {
                    promise.push(this.promiseRequest(id, apiUser))
                })
            })

            Promise.all(promise).then(() => {
                this.setState({users: res.data})
            })
        })
    }

    private promiseRequest = (id: string, apiUser: any) => {
        return new Promise(resolve => {
            this.requestAuthGroup(id).then(res => {
                apiUser.authGroupEntityList.push(res);
                resolve(res);
            })
        })


    }

    private getAuthGroup = (x: string, entity: AuthGroup) => {
        if (this.state.authGroups.has(x)) {
            return
        }
        this.requestAuthGroup(x).then((res) => {
            return
        })
    }

    private getTimeString = (datestr: Date): string => {
        let date = new Date(datestr)
        return getTimeString(date)
    }

    private requestAuthGroup = (id: string): Promise<any> => {
        return new Promise((resolve: any) => {
            request({
                url: "/gateway/authgroup/",
                params: {id: id},
                method: "GET"
            }).then(res => {
                this.setState((origin, props) => {
                    let item = new Map<string, AuthGroup>()
                    origin.authGroups.forEach((a: AuthGroup, key: string) => {
                        item.set(key, a)
                    })
                    item.set(id, res.data)
                    return {
                        authGroups: item
                    }
                })
                resolve(res.data)
            })
        })
    }

    componentDidMount() {
        this.loadData()
    }

    render() {
        return (
            <div>
                <Button type={"primary"} style={{marginBottom: 5}}
                        onClick={() => this.setState({apiUserEditVisible: true})}>创建ApiUser</Button>
                <Table columns={this.columns} dataSource={this.state.users}
                       rowKey={(record: ApiUser) => record.apiUserId}/>
                <Modal title="创建ApiUser"
                       width={800}
                       visible={this.state.apiUserEditVisible}
                       onCancel={() => {
                           this.apiUserEditRef.current!.clearForm()
                           this.setState({apiUserEditVisible: false})
                       }}
                       onOk={() => {
                           this.apiUserEditRef.current!.submitForm()
                       }}
                       cancelText='取消'
                       okText='新增'
                       forceRender
                >
                    <ApiUserEdit ref={this.apiUserEditRef} onEditSuccess={() => {
                        this.loadData()
                        this.setState({apiUserEditVisible: false})
                    }}
                    />
                </Modal>
            </div>
        )
    }
}
